import React from 'react';

// Founder UX Sprint — Suite Unification. Presentation-only guided empty state:
// explains why the section is empty, what to do next and what happens after.
// `cta` must be an EXISTING action (no new functionality).
export const GuidedEmptyState = ({ icon: Icon, title, why, steps = [], cta = null, dataTestId, compact = false }) => (
  <div className={`text-center ${compact ? 'py-6' : 'py-10'}`} data-testid={dataTestId}>
    {Icon && <Icon className={`mx-auto mb-3 text-muted-foreground/30 ${compact ? 'h-8 w-8' : 'h-12 w-12'}`} />}
    {title && <h3 className={`font-display font-bold ${compact ? 'text-sm' : 'text-lg'} mb-1.5`}>{title}</h3>}
    {why && <p className="text-sm text-muted-foreground max-w-md mx-auto">{why}</p>}
    {steps.length > 0 && (
      <ol className="mt-4 inline-flex flex-col items-start gap-1.5 text-left mx-auto">
        {steps.map((s, i) => (
          <li key={i} className="flex items-start gap-2 text-sm text-muted-foreground">
            <span className="h-5 w-5 rounded-full bg-primary/10 text-primary text-xs font-semibold flex items-center justify-center shrink-0 mt-0.5">{i + 1}</span>
            {s}
          </li>
        ))}
      </ol>
    )}
    {cta && <div className="mt-5">{cta}</div>}
  </div>
);

export default GuidedEmptyState;
